<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        :md=" chart.cols ? chart.cols: '6'"
        :chart-id="i"
        v-for="(chart, i) in chartsToRender"
        :key="i"
      >
        <chart-card-template
          :id="chart.id"
          :active="active"
          :hide-side-legend="!!chart.hideSideLegend"
          @resetCurrentChart="resetCurrentChart"
        >
          <template #title>
            <div class="card-title mr-2">{{ chart.title }}</div>
          </template>
          <template>
            <div class="d-flex chart-area">
              <div class="flex-grow-1" :ref="`chart`"></div>
            </div>
          </template>
        </chart-card-template>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapStores } from "pinia";
import ChartCardTemplate from "./ChartCardTemplate.vue";
import { useAnalyticsProStore } from "@/store/analyticsStore";
export default {
  mounted() {
    this.$nextTick(() => {
      const refs = this.$refs.chart || [];
      refs.forEach((el, i) => {
        this.$emit("chart-mounted", { id: el });
      });
    });
  },
  props: ["active", 'chartsToRender', 'overview'],
  emits: ["chart-mounted", "resetCurrentChart"],

  components: { ChartCardTemplate },
  methods: {
    resetCurrentChart(e) {
      this.$emit("resetCurrentChart", e);
    },
  },
  computed: { ...mapStores(useAnalyticsProStore) },
};
</script>
<style scoped>


.card-title
{
  width: 100%;
}
.chart-area {
  flex:auto;
  min-height: 0;
  width: 100%;
}
</style>
